const getIdToken = () => {
  return window.gapi.auth2.getAuthInstance().currentUser.get().getAuthResponse().id_token;
}

export default getIdToken;